<template>
    <div class="main">
        <div v-if="LOGIN" v-show="!SHOW_SEL">
            <div class="tctitle">
                <b></b><span>我要体检</span><b></b>
            </div>
            <div class="tables">
                <h3>新增项目：</h3>
                <table>
                    <thead>
                        <tr>
                            <td>序号</td>
                            <td>项目</td>
                            <td>临床意义</td>
                            <td>价格</td>
                            <td>取消</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(li,index) in ADDITEMS" :key="index"  v-tip.click="getTip1(li,false,index)"  :class="{rowactive:selIndex1==index}">
                            <td>{{index+1}}</td>
                            <td style="max-width:8em;">{{li.CHECKITEM_NAME}}</td>
                            <td style="min-width:10em;max-width:10em;">{{li.MEANING}}</td>
                            <td>{{li.ITEM_COST}}</td>
                            <td><i class="iconfont icon-error"  @click.stop="cancleItem(index)"></i></td>
                            <!-- <td><i class="iconfont icon-error"></i></td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="tctitle">
                <b></b><span>项目筛选</span><b></b>
            </div>
            <ul class="tctype">
                <li v-for="(li,index) in CATEGORYS" :key="index"><button type="button" @click="begreen(index)" :class="{green:changeGreen==index}"> {{li.NAME}}</button></li>
            </ul>
            <div class="tables">
                <table>
                    <thead>
                        <tr>
                            <td>序号</td>
                            <td>项目</td>
                            <td>临床意义</td>
                            <td>价格</td>
                            <td>添加</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(li,index) in CHECKITEMS" :key="index" v-tip.click="getTip2(li,false,index)"  :class="{rowactive:selIndex2==index}">
                            <td>{{index+1}}</td>
                            <td style="max-width:8em;">{{li.CHECKITEM_NAME}}</td>
                            <td style="min-width:10em;max-width:10em;">{{li.MEANING}}</td>
                            <td>{{li.ITEM_COST}}</td>
                            <td><i class="iconfont icon-jia" @click.stop="addItem(index)"></i></td>
                            <!-- <td><i class="iconfont icon-jia"></i></td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="buy">
                <!-- <div class="icons">
                                                                                    <i class="iconfont icon-star-copy"></i>
                                                                                </div>
                                                                                <div class="line"></div> -->
                <div class="icons">
                    <!-- <i class="iconfont icon-gouwuche" @click="goShopCart"></i> -->
                    <i :class="[SHOPCART?'iconfont icon-03f':'iconfont icon-gouwuche']" @click="goShopCart"></i>
                </div>
                <div class="line"></div>
                <div class="price">
                    <span>总价：¥{{PRICE}}</span>
                </div>
                <button class="btnbuy" @click="submit">立即购买</button>
            </div>
        </div>
        <div v-else>
            <login @finish="finish"></login>
        </div>
        <div v-show="SHOW_SEL">
            <personSel @INDIVIDUAL="selPerson" :action-type="ACTION"></personSel>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from "vuex";
    import api from "@/fetch/api";
    import login from '@/pages/login';
    import personSel from '@/pages/personSel'
    import itemTip from '@/components/itemInfo'
    import {
        Dialog,
        Toast
    } from 'vant';
    export default {
        data() {
            return {
                CATEGORYS: [],
                CHECKITEMS: [],
                changeGreen: 0,
                ADDITEMS: [],
                PRICE: 0,
                LOGIN: false,
                SHOW_SEL: false,
                ACTION: 0, //1:购物车，5：待付款
                SHOPCART: false,
                 selIndex1: -1,
                selIndex2: -1,
            }
        },
        components: {
            login,
            personSel,
            itemTip
        },
        created() {
            window.scroll(0, 0);
            sessionStorage.removeItem('records');
            if (this.userInfo.CUSTOMER_ID) {
                this.LOGIN = true;
                api.getItemCat().then(res => {
                    res.data.forEach(el => {
                        this.CATEGORYS.push({
                            ITEMCATEGORY_ID: el.ITEMCATEGORY_ID,
                            NAME: el.NAME
                        });
                    });
                    return this.CATEGORYS[0];
                }).then(v => {
                    api.getSingleCheck(v.ITEMCATEGORY_ID).then(re => {
                        re.data.forEach(el => {
                            this.CHECKITEMS.push({
                                CHECKITEM_ID: el.CHECKITEM_ID,
                                CHECKITEM_NAME: el.CHECKITEM_NAME,
                                ITEM_COST: el.ITEM_COST,
                                MEANING: el.MEANING
                            });
                        })
                    })
                });
            } else {
                this.LOGIN = false;
            }
        },
        methods: {
            finish(val) {
                this.LOGIN = val;
            },
            begreen(index) {
                this.changeGreen = index;
                api.getSingleCheck(this.CATEGORYS[index].ITEMCATEGORY_ID).then(re => {
                    this.CHECKITEMS = [];
                    re.data.forEach(el => {
                        this.CHECKITEMS.push({
                            CHECKITEM_ID: el.CHECKITEM_ID,
                            CHECKITEM_NAME: el.CHECKITEM_NAME,
                            ITEM_COST: el.ITEM_COST,
                            MEANING: el.MEANING
                        });
                    })
                });
            },
            goShopCart() {
                //加入购物车
                if (this.ADDITEMS.length < 1) {
                    Toast.fail({
                        message: '请添加体检项目',
                        duration: 1000
                    });
                    return false;
                }
                // let addItemIDs = [];
                // this.ADDITEMS.forEach(v => addItemIDs.push(v.CHECKITEM_ID));
                // let params = {
                //     COMBO_ID: '',
                //     addItemId: addItemIDs,
                //     STATUS: 1,
                //     PRICE: this.PRICE,
                //     TYPE: 3
                // };
                // let tjr = this.userInfo.CUSTOMER_ID;
                // console.log(tjr);
                // api.weixinOrder(tjr, this.userInfo.CUSTOMER_ID, params)
                //     .then(res => {
                //         Toast.success('添加购物车成功');
                //     });
                window.scroll(0, 0);
                this.ACTION = 1;
                this.SHOW_SEL = true;
            },
            selPerson(val) {
                console.log(val);
                this.SHOW_SEL = false;
                if (val != '' && val.INDIVIDUAL_ID != '' && val.INDIVIDUAL_ID != undefined) {
                    this.customerID = val.INDIVIDUAL_ID;
                    let addItemIDs = [];
                    this.ADDITEMS.forEach(v => addItemIDs.push(v.CHECKITEM_ID));
                    if (val.ACTIONTYPE == 1) {
                        //加入购物车
                        let params = {
                            COMBO_ID: '',
                            addItemId: addItemIDs,
                            STATUS: 1,
                            PRICE: this.PRICE,
                            TYPE: 3
                        };
                        api.weixinOrder(this.customerID, this.userInfo.CUSTOMER_ID, params)
                            .then(res => {
                                console.log(res);
                                if (res.result == true) {
                                    Toast.success({
                                        message: '添加购物车成功',
                                        duration: 1000
                                    });
                                    this.SHOPCART = true;
                                }
                            });
                    } else if (val.ACTIONTYPE == 5) {
                        //立即购买
                        // let params = {
                        //     COMBO_ID: '',
                        //     addItemId: addItemIDs,
                        //     STATUS: 5,
                        //     PRICE: this.PRICE,
                        //     TYPE: 3
                        // };
                        // api.weixinOrder(this.customerID, this.userInfo.CUSTOMER_ID, params)
                        //     .then(res => {
                        //         return res.data;
                        //     }).then(v => {
                        //         api.getCustomerInfo(this.customerID).then(re => {
                        //             let data = re.data;
                        //             let selItem = {
                        //                 PHONE_NUM: data.PHONE_NUM,
                        //                 PRICE: this.PRICE,
                        //                 RECORD_ID: v,
                        //                 TYPE: '单项检查',
                        //                 NAME: data.NAME
                        //             };
                        //             console.log(selItem);
                        //             sessionStorage.setItem('records', JSON.stringify(selItem));
                        //             this.$router.push('/user/confimOrder/' + v);
                        //         })
                        //     });
                        api.getCustomerInfo(this.customerID,this.userInfo.CUSTOMER_ID,this.userInfo.TOKEN).then(re => {
                            let data = re.data;
                            let selItem = {
                                PHONE_NUM: data.PHONE_NUM,
                                PRICE: this.PRICE,
                                RECORD_ID: '',
                                TYPE: '单项检查',
                                NAME: data.NAME,
                                customerID: this.customerID,
                                basicItems: [],
                                addItems: [],
                                COMBO_ID: '',
                                COMBO_TYPE: 3
                            };
                            this.ADDITEMS.forEach(v => selItem.addItems.push({
                                CHECKITEM_ID: v.CHECKITEM_ID,
                                CHECKITEM_NAME: v.CHECKITEM_NAME,
                                ITEM_COST: v.ITEM_COST
                            }));
                            console.log(selItem);
                            sessionStorage.setItem('records', JSON.stringify(selItem));
                            this.$router.push('/user/confimOrder/danxiang');
                        });
                    }
                }
            },
            submit() {
                //提交订单数据
                if (this.ADDITEMS.length < 1) {
                    Toast.fail({
                        message: '请添加体检项目',
                        duration: 1000
                    });
                    return false;
                }
                // let addItemIDs = [];
                // this.ADDITEMS.forEach(v => addItemIDs.push(v.CHECKITEM_ID));
                // let params = {
                //     COMBO_ID: '',
                //     addItemId: addItemIDs,
                //     STATUS: 5,
                //     PRICE: this.PRICE,
                //     TYPE: 3
                // };
                // let tjr = this.userInfo.CUSTOMER_ID;
                // console.log(tjr);
                // api.weixinOrder(tjr, this.userInfo.CUSTOMER_ID, params)
                //     .then(res => {
                //         return res.data;
                //     }).then(v => {
                //         api.getCustomerInfo(tjr).then(re => {
                //             let data = re.data;
                //             let selItem = {
                //                 PHONE_NUM: data.PHONE_NUM,
                //                 PRICE: this.PRICE,
                //                 RECORD_ID: v,
                //                 TYPE: '单项检查',
                //                 NAME: data.NAME
                //             };
                //             console.log(selItem);
                //             sessionStorage.setItem('records', JSON.stringify(selItem));
                //             this.$router.push('/user/confimOrder/' + v);
                //         })
                //     });
                window.scroll(0, 0);
                this.ACTION = 5;
                this.SHOW_SEL = true;
            },
            addItem(index) {
                // Dialog.confirm({
                //     title: '添加项目',
                //     message: '确定添加吗？'
                // }).then(() => {
                // }).catch(() => {
                // });
                if (this.ADDITEMS.findIndex(p => p.CHECKITEM_ID === this.CHECKITEMS[index].CHECKITEM_ID) === -1) {
                    this.ADDITEMS.push({
                        CHECKITEM_ID: this.CHECKITEMS[index].CHECKITEM_ID,
                        CHECKITEM_NAME: this.CHECKITEMS[index].CHECKITEM_NAME,
                        ITEM_COST: this.CHECKITEMS[index].ITEM_COST,
                        MEANING: this.CHECKITEMS[index].MEANING
                    });
                    Toast.success({
                        message: '添加成功！',
                        duration: 1000
                    });
                } else {
                    Toast.fail({
                        message: '您已添加该项目！',
                        duration: 1000
                    });
                }
                let price = 0;
                this.ADDITEMS.forEach(p => price += p.ITEM_COST);
                this.PRICE = price;
            },
            cancleItem(index) {
                // Dialog.confirm({
                //     title: '取消项目',
                //     message: '确定取消吗？'
                // }).then(() => {
                // }).catch(() => {
                //     // on cancel
                // });
                if (this.ADDITEMS.length > index) {
                    this.ADDITEMS.splice(index, 1);
                    let price = 0;
                    this.ADDITEMS.forEach(p => price += p.ITEM_COST);
                    this.PRICE = price;
                    Toast.success({
                        message: '取消成功！',
                        duration: 1000
                    });
                }
            },
            getTip(obj, enabled) {
                var that = this;
                return {
                    width: '80%',
                    transition: true,
                    container: document.getElementById('app'),
                    customProps: {
                        ITEM_NAME: obj.CHECKITEM_NAME,
                        PRICE: obj.ITEM_COST,
                        MEANING: obj.MEANING,
                        ENABLED: enabled,
                        STATUS: (that.ADDITEMS.findIndex(p => p.CHECKITEM_ID == obj.CHECKITEM_ID) > -1)
                    },
                    customListeners: {
                        operate(status) {
                            let index = that.ADDITEMS.findIndex(p => p.CHECKITEM_ID == obj.CHECKITEM_ID);
                            if (status) {
                                //选择
                                if (index == -1) {
                                    that.ADDITEMS.push({
                                        CHECKITEM_ID: obj.CHECKITEM_ID,
                                        CHECKITEM_NAME: obj.CHECKITEM_NAME,
                                        ITEM_COST: obj.ITEM_COST,
                                        MEANING: obj.MEANING
                                    });
                                    Toast.success({
                                        message: '添加成功！',
                                        duration: 1000
                                    });
                                }
                            } else {
                                //删除
                                if (index > -1) {
                                    that.ADDITEMS.splice(index, 1);
                                    Toast.success({
                                        message: '取消成功！',
                                        duration: 1000
                                    });
                                }
                            }
                            let price = 0;
                            that.ADDITEMS.forEach(p => price += p.ITEM_COST);
                            that.PRICE = parseFloat(price);
                            that.$tip().hiddenTip();
                        },
                        close() {
                            that.$tip().hiddenTip();
                        }
                    },
                    customComponent: itemTip
                }
            },
              getTip1(obj, enabled,index1) {
                var that = this;
                return {
                    width: '80%',
                    transition: true,
                    container: document.getElementById('app'),
                    customProps: {
                        ITEM_NAME: obj.CHECKITEM_NAME,
                        PRICE: obj.ITEM_COST,
                        MEANING: obj.MEANING,
                        ENABLED: enabled,
                        STATUS: (that.ADDITEMS.findIndex(p => p.CHECKITEM_ID == obj.CHECKITEM_ID) > -1),
                        SEL_INDEX: index1,
                    },
                    customListeners: {
                        operate(status) {
                            let index = that.ADDITEMS.findIndex(p => p.CHECKITEM_ID == obj.CHECKITEM_ID);
                            if (status) {
                                //选择
                                if (index == -1) {
                                    that.ADDITEMS.push({
                                        CHECKITEM_ID: obj.CHECKITEM_ID,
                                        CHECKITEM_NAME: obj.CHECKITEM_NAME,
                                        ITEM_COST: obj.ITEM_COST,
                                        MEANING: obj.MEANING
                                    });
                                    Toast.success({
                                        message: '添加成功！',
                                        duration: 1000
                                    });
                                }
                            } else {
                                //删除
                                if (index > -1) {
                                    that.ADDITEMS.splice(index, 1);
                                    Toast.success({
                                        message: '取消成功！',
                                        duration: 1000
                                    });
                                }
                            }
                            let price = 0;
                            that.ADDITEMS.forEach(p => price += p.ITEM_COST);
                            that.PRICE = parseFloat(price);
                            that.$tip().hiddenTip();
                        },
                        close() {
                            that.$tip().hiddenTip();
                        },
                         sel(val) {
                            that.selIndex1 = val;
                            that.selIndex2 = -1;
                            console.log(that.selIndex0)
                        },
                    },
                    customComponent: itemTip
                }
            },
             getTip2(obj, enabled,index2) {
                var that = this;
                return {
                    width: '80%',
                    transition: true,
                    container: document.getElementById('app'),
                    customProps: {
                        ITEM_NAME: obj.CHECKITEM_NAME,
                        PRICE: obj.ITEM_COST,
                        MEANING: obj.MEANING,
                        ENABLED: enabled,
                        STATUS: (that.ADDITEMS.findIndex(p => p.CHECKITEM_ID == obj.CHECKITEM_ID) > -1),
                        SEL_INDEX: index2,
                    },
                    customListeners: {
                        operate(status) {
                            let index = that.ADDITEMS.findIndex(p => p.CHECKITEM_ID == obj.CHECKITEM_ID);
                            if (status) {
                                //选择
                                if (index == -1) {
                                    that.ADDITEMS.push({
                                        CHECKITEM_ID: obj.CHECKITEM_ID,
                                        CHECKITEM_NAME: obj.CHECKITEM_NAME,
                                        ITEM_COST: obj.ITEM_COST,
                                        MEANING: obj.MEANING
                                    });
                                    Toast.success({
                                        message: '添加成功！',
                                        duration: 1000
                                    });
                                }
                            } else {
                                //删除
                                if (index > -1) {
                                    that.ADDITEMS.splice(index, 1);
                                    Toast.success({
                                        message: '取消成功！',
                                        duration: 1000
                                    });
                                }
                            }
                            let price = 0;
                            that.ADDITEMS.forEach(p => price += p.ITEM_COST);
                            that.PRICE = parseFloat(price);
                            that.$tip().hiddenTip();
                        },
                        close() {
                            that.$tip().hiddenTip();
                        },
                         sel(val) {
                               that.selIndex1 = -1;
                            that.selIndex2 = val;
                          
                            console.log(that.selIndex0)
                        },
                    },
                    customComponent: itemTip
                }
            }
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo"]),
            ...mapActions({
                setUserInfo: "setUserInfo"
            })
        }
    }
</script>

<style scoped lang="less">
    body {
        background-color: #fff;
    }
    .main {
        padding-bottom: 4em;
        .tables {
            font-size: 0.7rem;
            margin: 0 10px;
            padding: 10px 2px;
            .iconfont {
                border: 1px solid #aacd06;
                border-radius: 5px;
                font-size: 0.5rem;
                padding: 0.2rem;
                color: #fff;
                background-color: #aacd06;
                font-weight: bold;
            }
            h3 {
                padding: 0 5px;
            }
            .rowactive {
                background: #FF7C3E;
                td {
                    color: #fff !important;
                }
            }
        }
        .caption {
            margin: 0.5rem;
        }
        h1 {
            font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
            font-weight: 700;
            font-style: normal;
            font-size: 1rem;
            color: #43852E;
            text-align: center;
            margin: 0.5em 0;
        }
        b {
            display: inline-block;
            background-color: #66CCCC;
            width: 2px;
            height: 0.8rem;
        }
        span {
            font-size: 0.8rem;
            color: #797979;
            text-align: left;
        }
        ul {
            zoom: 1;
            margin: 0 10px;
            li {
                // height: 2.5em;
                width: 30%;
                float: left;
                margin: 0 0 2.5% 2.5%;
                button {
                    width: 100%;
                    height: 4em;
                    background: inherit;
                    background-color: rgba(255, 255, 255, 1);
                    box-sizing: border-box;
                    border-width: 1px;
                    border-style: solid;
                    border-color: #74b13f;
                    border-radius: 10px;
                    box-shadow: none;
                    color: #74b13f;
                    text-align: center;
                    font-size: 0.8em;
                }
            }
        }
        ul:after {
            display: block;
            clear: both;
            height: 0;
            content: '.';
            visibility: hidden;
        } // .tctype>li {
        //     margin: 0 1%;
        // }
        .tctitle {
            text-align: center;
            line-height: 2.5rem;
            b {
                display: inline-block;
                width: 5rem;
                height: 1px;
                background-color: rgb(51, 51, 51);
                ;
                vertical-align: middle;
                margin: 0 1rem;
            }
            span {
                font-size: 1rem;
                font-family: 'Arial Negreta', 'Arial Normal', 'Arial'; // font-weight: 700;
                color: rgb(51, 51, 51);
                ;
            }
        }
        .buy {
            font-family: "Microsoft YaHei" !important;
            position: fixed;
            bottom: 0;
            width: 100%; // border-top: 1px solid #ccc;
            height: 3em;
            line-height: 3em;
            color: #FF9966; // font-size: 0.6rem;
            font-size: 1rem;
            background: #fff;
            .btnbuy {
                padding: 0 1.5em;
            }
            button {
                position: absolute;
                top: 0;
                right: 0; // padding: 0 2em;
                line-height: 3em;
                height: 3em; // background: rgba(102, 204, 204, 1);
                color: #fff;
                border: none;
                box-shadow: -2px -2px 5px rgba(102, 102, 102, 0.349019607843137);
            }
            .line {
                width: 2px;
                height: 2em; // background: #ccc;
                margin-left: 1em;
                position: relative;
                top: 0.5em;
            }
            .price span {
                font-size: 1rem !important;
                margin-left: 1em;
            } // .icons i {
            //     color: rgba(102, 204, 204, 1);
            //     margin-left: 1rem;
            // }
        }
        .buy>div {
            display: inline-block;
        }
        .green {
            background: #74b13f;
            color: #fff;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/dxjc.vue